import { render, staticRenderFns } from "./Puzzle.vue?vue&type=template&id=c8fd8db6&"
import script from "./Puzzle.vue?vue&type=script&lang=ts&"
export * from "./Puzzle.vue?vue&type=script&lang=ts&"
import style0 from "./Puzzle.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports